/* ===== Firebase Configuration ===== */
import { firebaseStagingConfig } from './firebase-staging.js?v=83.21';

const firebaseConfigProduction = {
  apiKey: 'AIzaSyCWnnAs1TCXouwfvRY8idTrd75hLcQomWs',
  authDomain: 'spressjoy.firebaseapp.com',
  projectId: 'spressjoy',
  storageBucket: 'spressjoy.firebasestorage.app',
  messagingSenderId: '194111804711',
  appId: '1:194111804711:web:2630ae0a4072fd75030502',
  measurementId: 'G-03EW8HTYGS'
};

function isLocalHost() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname || '';
  return h === 'localhost' || h === '127.0.0.1';
}

/** URL-uri oficiale / preview Firebase Hosting pentru site-ul staging. */
function isStagingHostingHostname() {
  if (typeof window === 'undefined') return false;
  const h = (window.location.hostname || '').toLowerCase();
  if (h === 'spressjoy-staging.firebaseapp.com' || h === 'spressjoy-staging.web.app') return true;
  if (h.endsWith('.web.app') && h.startsWith('spressjoy-staging')) return true;
  return false;
}

function shouldPreferStagingCloud() {
  return isLocalHost() || isStagingHostingHostname();
}

function hasPlaceholder(value) {
  return (
    value == null ||
    (typeof value === 'string' && (value.includes('__REPLACE') || value.trim() === ''))
  );
}

function isStagingCloudReady(cfg) {
  if (!cfg || cfg.projectId !== 'spressjoy-staging') return false;
  if (hasPlaceholder(cfg.apiKey) || hasPlaceholder(cfg.messagingSenderId) || hasPlaceholder(cfg.appId)) {
    return false;
  }
  return true;
}

/** Config folosit la initializeApp (fără câmpuri placeholder opționale). */
function normalizeInitConfig(cfg) {
  const out = { ...cfg };
  if (hasPlaceholder(out.measurementId)) {
    delete out.measurementId;
  }
  return out;
}

function resolveFirebaseInitConfig() {
  if (shouldPreferStagingCloud() && isStagingCloudReady(firebaseStagingConfig)) {
    try {
      if (typeof console !== 'undefined' && console.info) {
        const where = isLocalHost() ? 'localhost' : 'staging-hosting';
        console.info('[SJ-Dev]', 'Firebase:', where, '→ spressjoy-staging (cloud)');
      }
    } catch (_) {}
    return normalizeInitConfig(firebaseStagingConfig);
  }
  if (shouldPreferStagingCloud() && !isStagingCloudReady(firebaseStagingConfig)) {
    try {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn(
          '[SJ-Dev]',
          'Staging cloud: completează public/js/config/firebase-staging.js din Firebase Console (spressjoy-staging). Folosesc producția.'
        );
      }
    } catch (_) {}
  }
  return normalizeInitConfig(firebaseConfigProduction);
}

const resolvedInitConfig = resolveFirebaseInitConfig();
export const firebaseConfig = resolvedInitConfig;

// Wait for Firebase to be available (it's loaded via script tags before modules)
if (typeof firebase === 'undefined') {
  if (typeof window !== 'undefined' && typeof window.showCriticalLoadError === 'function') {
    window.showCriticalLoadError('firebase-missing');
  }
  throw new Error('Firebase SDK not loaded! Make sure Firebase scripts are loaded before this module.');
}

// Initialize Firebase (only if not already initialized)
let app;
// Pagina publică /m/{slug} folosește o instanță Firebase separată („sj-public”), cu sesiune doar în memorie.
// Așa clientul nu e niciodată „logat” pe pagina publică, iar comerciantul NU este delogat din admin
// când își deschide propria pagină (înainte, setPersistence(NONE) pe instanța implicită ștergea sesiunea).
const SJ_PUBLIC_APP = typeof window !== 'undefined' && isPublicMerchantSlugPath() ? 'sj-public' : null;
try {
  app = SJ_PUBLIC_APP ? firebase.app(SJ_PUBLIC_APP) : firebase.app();
} catch (e) {
  try {
    app = SJ_PUBLIC_APP
      ? firebase.initializeApp(resolvedInitConfig, SJ_PUBLIC_APP)
      : firebase.initializeApp(resolvedInitConfig);
  } catch (initError) {
    if (typeof window !== 'undefined' && typeof window.showCriticalLoadError === 'function') {
      window.showCriticalLoadError('firebase-init');
    }
    throw initError;
  }
}

if (typeof window !== 'undefined' && isPublicMerchantSlugPath()) {
  try {
    if (typeof console !== 'undefined' && console.info) {
      console.info('[SJ-Public]', '[P4] Firebase app initialized');
    }
  } catch (_) {}
}

/** Link public /m/{slug} sau #/m/{slug} — același pattern ca în public-client.js */
function isPublicMerchantSlugPath() {
  if (typeof window === 'undefined') return false;
  try {
    const path = window.location.pathname || '';
    if (/^\/m\/[a-z0-9-]{3,48}\/?$/i.test(path)) return true;
    const hash = window.location.hash || '';
    return /^#(?:\/)?m\/[a-z0-9-]{3,48}\/?$/i.test(hash);
  } catch (_) {
    return false;
  }
}

// Export Firebase services
export { app };
export const auth = app.auth();
if (typeof window !== 'undefined' && isPublicMerchantSlugPath()) {
  auth.setPersistence(firebase.auth.Auth.Persistence.NONE).catch(() => {});
} else {
  auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
}

export const db = app.firestore();
if (typeof window !== 'undefined' && isPublicMerchantSlugPath()) {
  try {
    if (typeof console !== 'undefined' && console.info) {
      console.info('[SJ-Public]', '[P5] Firestore initialized (public /m/, long polling)');
    }
  } catch (_) {}
  try {
    /* Rețele mobile / firewall: WebChannel poate agăța; long polling e mai stabil pe Android Chrome. */
    db.settings({ experimentalForceLongPolling: true });
  } catch (e) {
    try {
      db.settings({ experimentalAutoDetectLongPolling: true });
    } catch (_) {}
  }
}
export const storage = app.storage();
export const INC = firebase.firestore.FieldValue.increment(1);

// ✅ Initialize Firebase Crashlytics (Web)
let crashlytics;
if (typeof firebase !== 'undefined' && firebase.crashlytics) {
  try {
    crashlytics = firebase.crashlytics();
    crashlytics.setCrashlyticsCollectionEnabled(true);
    console.log('[Crashlytics] Web enabled');
  } catch (err) {
    console.warn('[Crashlytics] Initialization failed:', err);
  }
}
export { crashlytics };

// ✅ Firestore offline persistence — NU pe /m/{slug}
if (typeof window !== 'undefined' && !isPublicMerchantSlugPath()) {
  try {
    db.enablePersistence({
      synchronizeTabs: true
    }).catch((err) => {
      if (err.code === 'failed-precondition') {
        console.warn('[Firestore] Offline persistence already enabled in another tab');
      } else if (err.code === 'unimplemented') {
        console.warn('[Firestore] Browser does not support offline persistence');
      } else {
        console.error('[Firestore] Error enabling persistence:', err);
      }
    });
  } catch (e) {
    console.warn('[Firestore] Could not enable persistence:', e);
  }
} else if (typeof window !== 'undefined' && isPublicMerchantSlugPath()) {
  console.info(
    '[Firestore] Public /m/: enablePersistence skipped; long polling on. (Dacă alt tab a pornit deja persistence pe același origin, SDK poate folosi tot IndexedDB — evită tab mixt admin + /m/.)'
  );
}
